var map = {
	"./google-laurel-da-DK.svg": 34295,
	"./google-laurel-de-DE.svg": 1893,
	"./google-laurel-en-GB.svg": 72967,
	"./google-laurel-en-US.svg": 60400,
	"./google-laurel-es-ES.svg": 58599,
	"./google-laurel-es-MX.svg": 13236,
	"./google-laurel-fr-FR.svg": 80187,
	"./google-laurel-it-IT.svg": 2957,
	"./google-laurel-nb-NO.svg": 57654,
	"./google-laurel-nl-NL.svg": 70995,
	"./google-laurel-pl-PL.svg": 55799,
	"./google-laurel-pt-BR.svg": 35991,
	"./google-laurel-pt-PT.svg": 20455,
	"./google-laurel-sv-SE.svg": 34473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;